import { baseNextjsUrl } from "@memorang/constants";

export const faqsEndpoint = `${baseNextjsUrl}/api/ai/app-faqs`;

export const dialogTexts = {
	faqs: {
		title: "dialog.faqs.title",
		body: "dialog.faqs.body",
	},
};
